// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--OUjNH","collapsed":"a10a3f92e9--collapsed--zBlUp","expanded":"a10a3f92e9--expanded--C6pzG"};